@if (status === 'completed') {
  <div class="icon-container">
    <fa-icon [icon]="'check'" class="text-white text-xs ml-[1px]"></fa-icon>
  </div>
} @else if (status === 'pending') {
  <div class="icon-container pending"></div>
} @else if (status === 'in_progress') {
  <mat-progress-spinner
    mode="indeterminate"
    [strokeWidth]="3"
    [diameter]="22"
  ></mat-progress-spinner>
} @else if (status === 'current') {
  <div class="icon-container current"></div>
}
